import TabSet from "../TabSet/TabSet"
import TileTypeSections from "./TileTypeSections"

export default function SelectTileType({
  activeTab,
  activeTileType,
  onSelectTileHandler,
  setActiveTabHandler,
  tabs,
}) {
  return (
    <>
      <TabSet
        tabs={tabs}
        onSelectTab={setActiveTabHandler}
        selectedTabKey={activeTab}
      />
      <>
        <p className="mb-4 px-4 italic">{activeTileType.description}</p>
        <div className="flex flex-1 flex-col overflow-hidden pb-4">
          <TileTypeSections
            sections={activeTileType.sections}
            selectTileHandler={onSelectTileHandler}
          />
        </div>
      </>
    </>
  )
}
